<div cdkDrag [cdkDragData]="data">
  <div [ngClass]="data.placeholderClassName" *cdkDragPlaceholder></div>
  <div 
    [id]="data.id" 
    class="widget-area" 
    [ngClass]="data.isSelected ? 'widget-selected' : 'widget-unselected'"
    cdkDropList 
    [cdkDropListConnectedTo]="dropListIds" 
    [cdkDropListData]="data.children"
    [cdkDropListEnterPredicate]="isDroppableWidget" 
    (cdkDropListDropped)="onDrop($event)">
    <!-- Titlebar for Widget -->
    <div class="widget-top-bar" fxLayout="row nowrap" fxLayoutAlign="end start">
      <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon>      
      <mat-label fxFlex="grow" title="{{ data.id }}" (click)="onSelect()"><b>Related Input</b><b *ngIf="data.label"> [{{data.label}}]</b></mat-label>
      <img src = "assets/img/icons/related-input.png">
      <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
      <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">minimize</mat-icon>
      <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMaximize()">settings</mat-icon>
    </div>
    <!-- Config data for Widget -->
    <div *ngIf="!isMinimized">
      <appMetadataRelatedInput [data]="data"></appMetadataRelatedInput>
    </div>

    <div *ngIf="!isMinimized" class="widget-config" fxLayout="column wrap">
      <h5 *ngIf="!isMinimized">Validations:</h5>
      <ng-container *ngFor="let widget of data.children">
        <ng-container [ngSwitch]="widget.widgetType">
          <div appValdnWidgetsComparison [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.VALDN_COMP"></div>
          <div appValdnWidgetsDate [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.VALDN_DATE"></div>
          <div appValdnWidgetsIP [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.VALDN_IP"></div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>